<template>
    <div class="leads-page">
       <div>
          <Contracts/>
       </div>
       
 
    </div>
 </template>
 
 <script>
 import Contracts from '@/components/Contracts/ContractsDashboard.vue';
 
 export default {
 
     components: {
         Contracts,
     },
 
 }
 </script>